export const aiMarketing = [
  {
    path: '/aiMarketing',
    name: 'aiMarketing',
    component: () => import('@/views/aiMarketing/index'),
    meta: {
      title: '智能营销',
      keepAlive: true
    }
  }
]
